import { useState } from "react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import { methods } from "../data/methodsData";

// Har bir metod uchun dars rejasi bosqichlari shabloni
const templates = {
    "3I": [
        { stage: "Individualizatsiya", desc: "Har bir o'quvchining ehtiyojini aniqlash, individual topshiriq berish (10 daq)" },
        { stage: "Interaksiya", desc: "Guruhda muhokama, rolli o'yin, o'zaro baholash (20 daq)" },
        { stage: "Integratsiya", desc: "Nazariy bilimlarni amaliy vaziyatga tatbiq qilish (15 daq)" },
    ],
    "CLIL": [
        { stage: "Content (Mazmun)", desc: "Mavzuning asosiy tushunchalarini taqdim etish (10 daq)" },
        { stage: "Communication (Muloqot)", desc: "Yangi terminlar bilan dialog va munozara (15 daq)" },
        { stage: "Cognition (Bilish)", desc: "Tahliliy savollar, taqqoslash topshiriqlari (10 daq)" },
        { stage: "Culture (Madaniyat)", desc: "Madaniy kontekst va misollar (10 daq)" },
    ],
    "SQ3R": [
        { stage: "Survey (Ko'zdan kechirish)", desc: "Matn sarlavhalarini, rasm va xulosalarini ko'rib chiqish (5 daq)" },
        { stage: "Question (Savol berish)", desc: "Sarlavhalardan savollar tuzish (5 daq)" },
        { stage: "Read (O'qish)", desc: "Savollarga javob izlab matnni o'qish (15 daq)" },
        { stage: "Recite (Takrorlash)", desc: "Asosiy fikrlarni o'z so'zlari bilan aytib berish (10 daq)" },
        { stage: "Review (Qayta ko'rib chiqish)", desc: "Umumiy xulosa va konspekt tuzish (10 daq)" },
    ],
    "GRASPS": [
        { stage: "Goal (Maqsad)", desc: "Vazifaning yakuniy maqsadini belgilash" },
        { stage: "Role (Rol)", desc: "O'quvchiga aniq rol berish (masalan: jurnalist, olim, mudir)" },
        { stage: "Audience (Auditoriya)", desc: "Kim uchun ishlashini aniqlash" },
        { stage: "Situation (Vaziyat)", desc: "Real hayotiy muammoli vaziyat tasviri" },
        { stage: "Product (Mahsulot)", desc: "Yakuniy mahsulot turi (taqdimot, maqola, video)" },
        { stage: "Standards (Standartlar)", desc: "Baholash mezonlari" },
    ],
    "SMART": [
        { stage: "Specific (Aniq)", desc: "Maqsadni aniq va tushunarli bayon qilish" },
        { stage: "Measurable (O'lchovli)", desc: "Natija qanday o'lchanishini belgilash" },
        { stage: "Achievable (Erishish mumkin)", desc: "Real va bajarish mumkin bo'lgan maqsad" },
        { stage: "Relevant (Ahamiyatli)", desc: "Mavzuga va o'quvchilarga mosligi" },
        { stage: "Time-bound (Muddatli)", desc: "Aniq muddat belgilash" },
    ],
    "WHERETO": [
        { stage: "W — Where & Why", desc: "Qayerga ketmoqdamiz, nima uchun?" },
        { stage: "H — Hook", desc: "O'quvchini qiziqtiruvchi kirish (5-10 daq)" },
        { stage: "E — Equip", desc: "Zaruriy bilim va vositalar bilan ta'minlash" },
        { stage: "R — Rethink", desc: "Qayta o'ylab ko'rish, mustahkamlash" },
        { stage: "E — Evaluate", desc: "O'z-o'zini baholash" },
        { stage: "T — Tailor", desc: "Individual ehtiyojlarga moslashtirish" },
        { stage: "O — Organize", desc: "Mantiqiy tartibda tashkil qilish" },
    ],
    "qosh_daraxt": [
        { stage: "Markaziy tushuncha", desc: "Mavzu yoki tushunchani markazga qo'yish" },
        { stage: "Birinchi daraxt — sabablar", desc: "Tushunchaning sabab va manbalari shoxlari" },
        { stage: "Ikkinchi daraxt — natijalar", desc: "Oqibat va natija shoxlari" },
        { stage: "Bog'lanishlar", desc: "Ikki daraxt o'rtasidagi mantiqiy aloqalarni ko'rsatish" },
        { stage: "Xulosa", desc: "Umumlashtirish va munozara" },
    ],
};

function LessonPlanner() {
    const [form, setForm] = useState({
        teacher: "",
        subject: "",
        topic: "",
        grade: "",
        duration: "45",
        methodId: "3I",
        goal: "",
    });

    const stages = templates[form.methodId] || [];
    const method = methods.find((m) => m.id === form.methodId);

    const exportPDF = () => {
        const doc = new jsPDF();
        let y = 20;
        doc.setFontSize(18);
        doc.text("DARS REJASI", 105, y, { align: "center" });
        y += 15;

        doc.setFontSize(11);
        const rows = [
            ["Tarbiyachi / O'qituvchi:", form.teacher || "—"],
            ["Fan:", form.subject || "—"],
            ["Mavzu:", form.topic || "—"],
            ["Sinf / Guruh:", form.grade || "—"],
            ["Davomiyligi:", form.duration + " daqiqa"],
            ["Metod:", method?.name || "—"],
            ["Maqsad:", form.goal || "—"],
        ];
        rows.forEach(([k, v]) => {
            doc.setFont(undefined, "bold");
            doc.text(k, 20, y);
            doc.setFont(undefined, "normal");
            const lines = doc.splitTextToSize(String(v), 120);
            doc.text(lines, 70, y);
            y += lines.length * 7;
        });

        y += 8;
        doc.setFontSize(14);
        doc.setFont(undefined, "bold");
        doc.text("BOSQICHLAR (" + (method?.name || "") + ")", 20, y);
        y += 10;

        doc.setFontSize(11);
        stages.forEach((s, i) => {
            if (y > 270) { doc.addPage(); y = 20; }
            doc.setFont(undefined, "bold");
            doc.text(`${i + 1}. ${s.stage}`, 20, y);
            y += 7;
            doc.setFont(undefined, "normal");
            const lines = doc.splitTextToSize(s.desc, 170);
            doc.text(lines, 25, y);
            y += lines.length * 6 + 4;
        });

        y += 10;
        doc.setFontSize(10);
        doc.setTextColor(120);
        doc.text("Mushtariy ta'lim platformasi | Dars rejasi generatori", 105, 290, { align: "center" });

        doc.save(`dars_rejasi_${form.methodId}_${Date.now()}.pdf`);
    };

    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>Dars rejasi generatori</span></li>
                        </ul>
                        <h2 className="page-header__title">Dars rejasi generatori</h2>
                    </div>
                </div>
                <img src="/assets/images/page-header-shape-1.png" alt="shape" className="page-header__shape-one" />
                <img src="/assets/images/page-header-shape-2.png" alt="shape" className="page-header__shape-two" />
            </section>

            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Tayyor dars rejasini tuzing</h3>
                                <p className="pricing-one__text">
                                    Ma'lumotlarni kiriting va tanlangan metod asosida tayyor dars rejasini PDF formatda yuklab oling.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div className="row gutter-y-30">
                                <div className="col-md-6">
                                    <label className="d-block mb-2"><strong>Tarbiyachi / O'qituvchi F.I.O</strong></label>
                                    <input type="text" className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.teacher} onChange={(e) => setForm({ ...form, teacher: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="d-block mb-2"><strong>Fan</strong></label>
                                    <input type="text" className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="d-block mb-2"><strong>Mavzu</strong></label>
                                    <input type="text" className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="d-block mb-2"><strong>Sinf / Guruh</strong></label>
                                    <input type="text" className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.grade} onChange={(e) => setForm({ ...form, grade: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="d-block mb-2"><strong>Davomiyligi (daq)</strong></label>
                                    <input type="number" className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.duration} onChange={(e) => setForm({ ...form, duration: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="d-block mb-2"><strong>Metod</strong></label>
                                    <select className="form-control"
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.methodId} onChange={(e) => setForm({ ...form, methodId: e.target.value })}>
                                        {methods.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="d-block mb-2"><strong>Dars maqsadi</strong></label>
                                    <textarea className="form-control" rows={2}
                                        style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                        value={form.goal} onChange={(e) => setForm({ ...form, goal: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Ko'rinish: {method?.name}</h3>
                            </div>
                            <button onClick={exportPDF} className="eduhive-btn" style={{ border: "none" }}>
                                <span>PDF yuklab olish</span>
                                <span className="eduhive-btn__icon">
                                    <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                </span>
                            </button>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div style={{ background: "#fff", padding: "30px", borderRadius: "12px", border: "1px solid #eee" }}>
                                <h3 style={{ textAlign: "center", marginBottom: "20px" }}>DARS REJASI</h3>
                                <table style={{ width: "100%", marginBottom: "30px" }}>
                                    <tbody>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600, width: "200px" }}>Tarbiyachi:</td><td>{form.teacher || "—"}</td></tr>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600 }}>Fan:</td><td>{form.subject || "—"}</td></tr>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600 }}>Mavzu:</td><td>{form.topic || "—"}</td></tr>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600 }}>Sinf:</td><td>{form.grade || "—"}</td></tr>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600 }}>Davomiylik:</td><td>{form.duration} daqiqa</td></tr>
                                        <tr><td style={{ padding: "6px 0", fontWeight: 600 }}>Maqsad:</td><td>{form.goal || "—"}</td></tr>
                                    </tbody>
                                </table>
                                <h4 style={{ marginBottom: "15px", color: "#ffb606" }}>Bosqichlar</h4>
                                {stages.map((s, i) => (
                                    <div key={i} style={{
                                        padding: "15px 20px",
                                        background: i % 2 ? "#fafafa" : "#fff",
                                        borderLeft: "4px solid #ffb606",
                                        marginBottom: "10px",
                                        borderRadius: "4px"
                                    }}>
                                        <strong>{i + 1}. {s.stage}</strong>
                                        <p style={{ margin: "5px 0 0", color: "#555" }}>{s.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default LessonPlanner;
